import React from 'react';
import Loading from 'flow/components/ui-components/Loading';
import useAppContext from 'flow/hooks/useAppContext';
import useCountdown from 'flow/hooks/useCountdown';
import { translateNumber } from 'flow/utils/browser-utils';

interface Props {
    onComplete: () => void;
}

const UaePassSuccessState: React.FC<Props> = ({ onComplete }) => {
    const { i18next } = useAppContext();
    const redirectIn = useCountdown(3, onComplete);

    return (
        <output className="flex flex-col items-center gap-6 pt-4 text-center">
            <h2 className="text-xl font-bold tracking-tight">
                {i18next.t(
                    'uaepass.success.title',
                    'You are now authenticated via UAE PASS',
                )}
            </h2>

            <Loading size={44} disableTimeout={true} />

            <div className="text-xs text-gray-500 dark:text-gray-200">
                {i18next.t(
                    'uaepass.success.redirecting',
                    'Redirecting in {{count}}s',
                    { count: translateNumber(redirectIn) },
                )}
            </div>
        </output>
    );
};

export default UaePassSuccessState;
